import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {getToken, setToken, removeToken, setLoginMethod} from '@/utils/auth';

import Cookies from 'js-cookie';

import Element from 'element-ui';

import 'element-ui/lib/theme-chalk/display.css'; // 仅引入显示样式
//import '@/assets/styles/element-variables.scss';
import '@/assets/styles/index.scss'; // global css
import '@/assets/styles/ruoyi.scss'; // ruoyi css
import '@/assets/styles/styles.scss'; // styles css

import StepsComponent from '@/components/Steps';
// 文件上传组件
import FileUpload from '@/components/FileUpload';
// 图片上传组件
import ImageUpload from '@/components/ImageUpload';
// excel预览组件
import ExcelViewer from '@/components/ExcelViewer.vue';

import { parseTime } from '@/utils/ruoyi';
// 全局方法挂载
Vue.prototype.parseTime = parseTime;

// 全局组件挂载
Vue.component('FileUpload', FileUpload);
Vue.component('ImageUpload', ImageUpload);
Vue.component('StepsComponent', StepsComponent);
Vue.component('ExcelViewer', ExcelViewer);

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
});

Vue.config.productionTip = false;

// 解析URL参数
const initFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  console.log(params, 'params======');
  // 获取 token 参数
  const token = params.get('token');
  console.log(token, 'token===================');
  const userName = params.get('userName');
  console.log(userName, 'userName===================');
  const userId = params.get('userId');
  console.log(userId, 'userId===================');
  const phone = params.get('phone');
  console.log(phone, 'phone===================');

  // 创建 userInfo 对象
  const userInfo = {
    token: token || null,
    userName: userName || null,
    username: userName || null,
    userId: userId || null,
    phone: phone || null,
    idCard: userName || null,
  };

  if (token) {//有token应该是卫生中心过来的
    // 清除旧token
    if (getToken()) {
      removeToken();
    }
    setToken(token);
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
    }
    localStorage.setItem('token', token);
    // 将 userInfo 对象存储到 localStorage
    if (localStorage.getItem('userInfo')) {
      localStorage.removeItem('userInfo');
    }
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    console.log('userInfo-------', localStorage.getItem('userInfo'));

    store.commit('SET_USERINFO', JSON.stringify(userInfo));

    //同步数据
    store.dispatch('getUserInfoVar', userInfo);
  }
};

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    initFromURL();
  },
}).$mount('#app');
